import RequestPrescreenerBaseCategoryController from './prescreener--base-category';

export default class RequestPrescreenerAdministrative extends RequestPrescreenerBaseCategoryController {}
